import * as React from 'react'
import { SVGProps } from 'react'

const EOSUSD = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M15.994 31.9881C7.19732 31.9881 0 24.7909 0 15.9144C0.0799702 7.11786 7.19732 -0.0793086 16.074 0.000660027C24.8707 0.0806286 31.9881 7.19783 31.9881 16.1543C31.9081 24.8709 24.7908 31.9881 15.994 31.9881Z'
      fill='white'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10.8868 12.1982L15.8769 5.33142L20.8244 12.1555L22.9569 22.3491L15.8769 26.6568L8.79688 22.3491L10.8868 12.1982ZM11.5262 14.1601L9.94812 21.8799L15.1089 25.0361L11.5262 14.1601ZM12.0371 12.4114L15.8757 7.12274L19.7143 12.4114L15.8757 24.0125L12.0371 12.4114ZM20.1852 14.1602L16.6025 25.0361L21.7633 21.8799L20.1852 14.1602Z'
      fill='black'
    />
  </svg>
)

export default EOSUSD
